import React from 'react'
import Svg from './Svg'
export const SvgChevronDown = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M12.004 14.085l9.441-9.441L24 7.198 12.004 19.195 0 7.194l2.556-2.553z" />
  </Svg>
))
SvgChevronDown.isIcon = true
export default SvgChevronDown
